import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

interface TipRelatedIds {
  divisionId: number;
  phaseId: number;
  tipId: number;
}

// Parse /phases/3/2/tips/7 and extract divisionId - 3, phaseId -2 and tipId(optional) - 7
const DIVISION_AND_PHASE_IDS_URL_PATTERN_MATCH = /phases\/(?<divisionId>\w+)\/(?<phaseId>\d+)\/tips(?:\/(?<tipId>\d+))?/;

@Injectable({ providedIn: 'root' })
export class PhaseTipIdsResolver implements Resolve<TipRelatedIds> {
  resolve(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): TipRelatedIds {
    const matches = state.url.match(DIVISION_AND_PHASE_IDS_URL_PATTERN_MATCH);
    const { divisionId, phaseId, tipId } = matches.groups;

    return { divisionId: Number(divisionId), phaseId: Number(phaseId), tipId: Number(tipId) };
  }
}
